import axiosInstance from './AxiosInstance';

const API_URL = 'roles';

export const getRoles = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching roles', error);
        throw error;
    }
};

export const getRoleById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching role with id ${id}`, error);
        throw error;
    }
};

export const createRole = async (role) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, role);
        return response.data;
    } catch (error) {
        console.error('Error creating role', error);
        throw error;
    }
};

export const updateRole = async (id, role) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...role });
        return response.data;
    } catch (error) {
        console.error(`Error updating role with id ${id}`, error);
        throw error;
    }
};

export const deleteRole = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting role with id ${id}`, error);
        throw error;
    }
};

